<div class="content content-fixed">
  <div class="container">
    <div class="text-xl mb-3 normal-case">Patron Search</div>

    <!-- Success Message -->
    <div *ngIf="successMessage" class="mb-4 p-4 bg-green-100 border border-green-400 text-green-700">
      <div class="flex items-center">
        <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd"
          ></path>
        </svg>
        {{ successMessage }}
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="mb-4 p-4 bg-red-100 border border-red-400 text-red-700">
      <div class="flex items-center">
        <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          ></path>
        </svg>
        {{ errorMessage }}
      </div>
    </div>

    <div class="w-full flex flex-wrap bg-white rounded-md shadow-lg p-4 flex-col gap-6">
      <div class="flex flex-col gap-3">
        <div class="flex justify-between items-center">
          <app-label for="searchQuery">Search Patron</app-label>
          <button class="btn btn-primary" (click)="openCreateDialog()">Create Patron</button>
        </div>
        <app-input
          id="searchQuery"
          name="searchQuery"
          type="text"
          placeholder="Search by Name, SSN, Email..."
          (input)="onSearchInput($event)"
        ></app-input>
        <div *ngIf="isLoading" class="text-blue-500">Searching...</div>
      </div>
    </div>

    <!-- Search Results Table -->
    <div *ngIf="searchResults.length > 0" class="mt-6">
      <div class="text-lg font-semibold mb-4">Search Results ({{ searchResults.length }} found)</div>

      <div class="table-container">
        <table class="patron-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>DOB</th>
              <th>SSN</th>
              <th>Phone</th>
              <th>Email</th>
              <th>City</th>
              <th>State</th>
              <th>Zip</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let patron of searchResults">
              <td>{{ patron.name }}</td>
              <td>{{ patron.dateOfBirth }}</td>
              <td>{{ patron.ssn }}</td>
              <td>{{ patron.phoneNumber }}</td>
              <td>{{ patron.email }}</td>
              <td>{{ patron.city }}</td>
              <td>{{ patron.state }}</td>
              <td>{{ patron.postalCode }}</td>
              <td>
                <button
                  class="btn btn-primary"
                  (click)="addToSearchQueue(patron.candidateId)"
                  [disabled]="isAddingToSearchQueue"
                >
                  <span *ngIf="isAddingToSearchQueue" class="spinner-border spinner-border-sm mr-2"></span>
                  Add to Search Queue
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- No Results Message -->
    <div
      *ngIf="searchResults.length === 0 && !isLoading && searchResults.length !== undefined"
      class="mt-6 text-center text-gray-500"
    >
      No results found. Try a different search term.
    </div>
  </div>
</div>

<!-- Inline Create Patron Dialog -->
<div *ngIf="showCreateDialog" class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
  <div class="bg-white rounded-md shadow-xl w-full max-w-lg p-6">
    <div class="text-lg font-semibold mb-4">Create Patron</div>

    <div class="grid grid-cols-1 gap-4">
      <div class="grid grid-cols-2 gap-3">
        <div>
          <app-label for="firstName">First Name<span class="text-red-500">*</span></app-label>
          <app-input id="firstName" name="firstName" type="text" [(ngModel)]="createForm.firstName"></app-input>
        </div>
        <div>
          <app-label for="lastName">Last Name<span class="text-red-500">*</span></app-label>
          <app-input id="lastName" name="lastName" type="text" [(ngModel)]="createForm.lastName"></app-input>
        </div>
      </div>
      <div>
        <app-label for="dob">Date of Birth<span class="text-red-500">*</span></app-label>
        <app-input id="dob" name="dob" type="date" [(ngModel)]="createForm.date_of_birth"></app-input>
      </div>
      <div>
        <app-label for="ssn">SSN</app-label>
        <app-input id="ssn" name="ssn" type="text" [(ngModel)]="createForm.ssn"></app-input>
      </div>
      <div>
        <app-label for="address">Address</app-label>
        <app-input id="address" name="address" type="text" [(ngModel)]="createForm.address"></app-input>
      </div>
      <div class="grid grid-cols-3 gap-3">
        <div>
          <app-label for="city">City</app-label>
          <app-input id="city" name="city" type="text" [(ngModel)]="createForm.city"></app-input>
        </div>
        <div>
          <app-label for="state">State</app-label>
          <app-input id="state" name="state" type="text" [(ngModel)]="createForm.state"></app-input>
        </div>
        <div>
          <app-label for="postalCode">ZIP</app-label>
          <app-input id="postalCode" name="postalCode" type="text" [(ngModel)]="createForm.postal_code"></app-input>
        </div>
      </div>
      <div>
        <app-label for="refId">Loyalty Reward Number</app-label>
        <app-input id="refId" name="refId" type="text" [(ngModel)]="createForm.ref_id"></app-input>
      </div>
    </div>

    <div class="flex justify-end gap-3 mt-6">
      <button class="btn" (click)="closeCreateDialog()" [disabled]="isSubmitting">Cancel</button>
      <button class="btn btn-primary" (click)="submitCreatePatron()" [disabled]="!canSubmitCreate()">
        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm mr-2"></span>
        Create
      </button>
    </div>
  </div>
</div>
